/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes { 
  GET_PREMIUM_LINES = '[Premium Ride] Get Premium Lines',
  GET_PREMIUM_LINES_SUCCESS = '[Premium Ride] Get Route Premium Success',
  FIND_RIDE = '[Premium Ride] Find Ride',
  FIND_RIDE_SUCCESS = '[Premium Ride] Find Ride Success',
  BOOK_RIDE = '[Premium Ride] Book Ride',
  BOOK_RIDE_SUCCESS = '[Premium Ride] Book Ride Success',
  CANCEL_RIDE = '[Premium Ride] Cancel Ride',
  CANCEL_RIDE_SUCCESS = '[Premium Ride] Cancel Ride Success',
  TRACK_RIDE = '[Premium Ride] Track Ride',
  TRACK_RIDE_SUCCESS = '[Premium Ride] Track Ride Success',
  GET_PREMIUM_BUS_ACTIVITY = '[Premium Ride] Get Premium Bus Activity',
  GET_PREMIUM_BUS_ACTIVITY_SUCCESS = '[Premium Ride] Get Premium Bus Activity',
  WAIT_PREMIUM_RIDE = '[Premium Ride] Wait Premium Ride',
  WAIT_PREMIUM_RIDE_SUCCESS = '[Premium Ride] Wait Premium Ride Success',
  FIND_MULTIPLE_RIDES = '[Premium Ride] Find Multiple Rides',
  FIND_MULTIPLE_RIDES_SUCCESS = '[Premium Ride] Find Multiple Rides Success',
}

export const getPremiumLines = createAction(
  ActionTypes.GET_PREMIUM_LINES
);

export const getPremiumLinesSuccess = createAction(
  ActionTypes.GET_PREMIUM_LINES_SUCCESS,
  props<{ data: any }>()
);

export const findRide = createAction(
  ActionTypes.FIND_RIDE,
  props<{ data: any, selectedRoute: any}>()
);

export const findRideSuccess = createAction(
  ActionTypes.FIND_RIDE_SUCCESS,
  props<{ data: any, selectedRoute: any }>()
);

export const bookRide = createAction(
  ActionTypes.BOOK_RIDE,
  props<{ data: any }>()
);

export const bookRideSuccess = createAction(
  ActionTypes.BOOK_RIDE_SUCCESS,
  props<{ data: any }>()
);

export const cancelRide = createAction(
  ActionTypes.CANCEL_RIDE,
  props<{ data: any }>()
);

export const cancelRideSuccess = createAction(
  ActionTypes.CANCEL_RIDE_SUCCESS,
  props<{ data: any }>()
);

export const trackRide = createAction(
  ActionTypes.TRACK_RIDE,
  props<{ data: any }>()
);

export const trackRideSuccess = createAction(
  ActionTypes.TRACK_RIDE_SUCCESS,
  props<{ data: any, premiumRouteInfo: any }>()
);

export const getPremiumBusActivity = createAction(
  ActionTypes.GET_PREMIUM_BUS_ACTIVITY,
  props<{ data: any, busInfo: any, routeInfo: any }>()
);

export const getPremiumBusActivitySuccess = createAction(
  ActionTypes.GET_PREMIUM_BUS_ACTIVITY_SUCCESS,
  props<{ data: any, busInfo: any }>()
);

export const waitPremiumRide = createAction(
  ActionTypes.WAIT_PREMIUM_RIDE,
  props<{ data: any }>()
);

export const waitPremiumRideSuccess = createAction(
  ActionTypes.WAIT_PREMIUM_RIDE_SUCCESS,
  props<{ data: any}>()
);

export const findMultipleRides = createAction(
  ActionTypes.FIND_MULTIPLE_RIDES,
  props<{ data: any, details: any }>()
);

export const findMultipleRidesSuccess = createAction(
  ActionTypes.FIND_MULTIPLE_RIDES_SUCCESS,
  props<{ data: any, details: any}>()
);